'use strict';

import VendorPlugins from "./VendorPlugins";

class CornerSelect {
    static get cornerSVG() {
        return '' +
        '<svg viewBox="0 0 750 440" xmlns="http://www.w3.org/2000/svg">' +
            '<g class="left">' +
                '<path class="sec" d="M 255 190 L 495 190 L 495 250 L 315 250 L 255 190 Z" transform="matrix(0, -1, 1, 0, 65, 505)"/>' +
                '<circle class="label-circle" cx="285" cy="78" r="15"/>' +
                '<text class="badge" x="278" y="85">X</text>' +
                '<path class="arc" d="m 315,140 h 50 v 50" />' + //1
                '<text class="arc-badge" y="173.19368" x="323.03436">C</text>' +
            '</g>' +
            '<g class="right">' +
                '<path class="sec" d="M 346.527 161.527 L 586.527 161.527 L 586.527 101.527 L 406.527 101.527 L 346.527 161.527 Z" transform="matrix(0, -1, 1, 0, 333.473116, 596.52711)"/>' +
                '<circle class="label-circle" cx="465" cy="78" r="15"/>' +
                '<text class="badge" x="458" y="85">X</text>' +
                '<path class="arc" d="m 385.00012,190.00011 v -50 h 50" />' + //2
                '<text class="arc-badge" x="395.09161" y="178.68979">C</text>' +
            '</g>' +
            '<g class="right">' +
                '<path class="sec" d="M 441.277 112.85 L 681.277 112.85 L 655.496 172.85 L 441.277 172.85 L 441.277 112.85 Z" transform="matrix(-0.707063, 0.707151, -0.707151, -0.707063, 1056.545067, -151.97382)"/>' +
                '<circle class="label-circle" cx="565" cy="140" r="15"/>' +
                '<text class="badge" x="558" y="147">X</text>' +
                '<path class="arc" d="m 425.83704,189.34498 a 45,45 0 0 1 27.77924,-41.57457 45,45 0 0 1 49.04056,9.75477" />' + //3
                '<text class="arc-badge" y="176.19118" x="444.31424">C</text>' +
            '</g>' +
            '<g class="right">' +
                '<path class="sec" d="M 441.277 327.15 L 681.277 327.15 L 655.496 267.15 L 441.277 267.15 L 441.277 327.15 Z" transform="matrix(-0.707063, -0.707151, 0.707151, -0.707063, 745.398693, 903.081436)"/>' +
                '<circle class="label-circle" cx="565" cy="300" r="15"/>' +
                '<text class="badge" x="558" y="307">X</text>' +
                '<path class="arc" d="m 502.65693,282.47471 a 45,45 0 0 1 -49.15995,9.70512 45,45 0 0 1 -27.65911,-41.78354" />' + //4
                '<text class="arc-badge" x="443.81424" y="278.69119">C</text>' +
            '</g>' +
            '<g class="right">' +
                '<path class="sec" d="M 346.527 278.473 L 586.527 278.473 L 586.527 338.473 L 406.527 338.473 L 346.527 278.473 Z" transform="matrix(0, 1, -1, 0, 773.473105, -156.527121)"/>' +
                '<circle class="label-circle" cx="465" cy="362" r="15"/>' +
                '<text class="badge" x="458" y="369">X</text>' +
                '<path class="arc" d="m 434.71124,300.10099 h -50 v -50" />' + //5
                '<text class="arc-badge" y="280.44022" x="397.09021">C</text>' +
            '</g>' +
            '<g class="left">' +
                '<path class="sec" d="M 166.527 338.473 L 406.527 338.473 L 406.527 278.473 L 226.527 278.473 L 166.527 338.473 Z" transform="matrix(0, 1, -1, 0, 593.473112, 23.472872)"/>' +
                '<circle class="label-circle" cx="285" cy="362" r="15"/>' +
                '<text class="badge" x="278" y="369">X</text>' +
                '<path class="arc" d="m 364.50028,250.60071 v 50 h -50" />' + //6
                '<text class="arc-badge" x="324.78506" y="282.44104">C</text>' +
            '</g>' +
            '<g class="left">' +
                '<path class="sec" d="M 71.716 267.15 L 311.716 267.15 L 285.935 327.15 L 71.716 327.15 L 71.716 267.15 Z" transform="matrix(0.707063, -0.707151, 0.707151, 0.707063, -154.416382, 221.538703)"/>' +
                '<circle class="label-circle" cx="185" cy="300" r="15"/>' +
                '<text class="badge" x="178" y="307">X</text>' +
                '<path class="arc" d="m 324.10211,250.65514 a 45,45 0 0 1 -27.77924,41.57458 45,45 0 0 1 -49.04056,-9.75478" />' + //7
                '<text class="arc-badge" y="282.19119" x="272.31424">C</text>' +
            '</g>' +
            '<g>' +
                '<rect class="sec" width="240" height="60" x="255" y="190"/>' +
                '<circle class="label-circle" cx="375" cy="220" r="15"/>' +
                '<text class="badge" x="368" y="227">2</text>' +
            '</g>' +

            '<g class="left active">' +
                '<path class="sec" d="M 71.716 172.85 L 311.716 172.85 L 285.935 112.85 L 71.716 112.85 L 71.716 172.85 Z" transform="matrix(0.707063, 0.707151, -0.707151, 0.707063, 156.72998, -92.646307)"/>' +
                '<circle class="label-circle" cx="185" cy="140" r="15"/>' +
                '<text class="badge" x="178" y="147">1</text>' +
                '<path class="arc" d="m 247.28225,157.52517 a 45,45 0 0 1 49.04055,-9.75478 45,45 0 0 1 27.77925,41.57458" />' +
                '<text class="arc-badge" x="269.31424" y="177.69118">C1</text>' +
            '</g>' +
        '</svg>';
    }
    // static get boxSuffix() {return "_Interactive";}
    static get cornerImageSuffix() {return "_corner-image";}
    static get visotaSuffix() {return "_visota";}
    static get shirinaSuffix() {return "_shirina";}
    static get dlina1Suffix() {return "_dlina1";}
    static get dlina2Suffix() {return "_dlina2";}
    static get dlina3Suffix() {return "_dlina3";}
    static get ugol1Suffix() {return "_ugol1";}
    static get ugol2Suffix() {return "_ugol2";}

    constructor(variants = ["ITTC"], selectBox = "CornerSelectBox", initALL = true) {
        this.variants = variants;
        this.selectBox = selectBox;
        console.log(`Init ${this.variants} interactive box module`);
        if (initALL) this.initDefaultImage().initDialog();
    }

    initDefaultImage () {
        for (let i = 0; i < this.variants.length; i++) {
            $("#" + this.variants[i] + CornerSelect.cornerImageSuffix).html(CornerSelect.cornerSVG);
        }
        return this;
    }
    initDialog() {
        // init interactive act
        let $svg = $('#' + this.selectBox + ' .corner-select-interactive-component').html(CornerSelect.cornerSVG);
        let $rect = $svg.find('rect');
        if (!$svg || !$rect) return;

        $svg.find('g').click((event) => {
            let $this = $(event.currentTarget),
                isActive = $this.hasClass('active'),
                $actives = $this.parent().find('.active');

            if(($this.has('rect').length > 0) || ($actives.length < 2 && $actives.is($this)))
                return;

            if ($this.hasClass('left')) {
                $actives.filter('.left').removeClass('active');
            }
            else if ($this.hasClass('right'))
                $actives.filter('.right').removeClass('active');

            if(!isActive) $this.addClass('active');

            this.onChange();
        });
        this.onChange();

        $('#' + this.selectBox)
            .on('shown.bs.modal', (event) => this.loadControlsValues(event))
            .on('hidden.bs.modal', () => this.finalizeBox())
            .on('keypress', (event) => {
                if (event.keyCode === 10 || event.keyCode === 13) {
                    this.onConfirm(event);
                    event.preventDefault();
                }
            })
            .find("button.confirm")
                .on('click', (event) => this.onConfirm(event));

        return this;
    }
    cloneOptions($srcSelect, $dstSelect) {
        $dstSelect.empty();
        $srcSelect.find('> option').each((index, item) => $dstSelect.append("<option value='" + item.value + "'" + (item.disabled ? "disabled" : "") + ">" + item.innerText + "</option>"));
        $dstSelect.val($srcSelect.val());

// console.log($srcSelect.prop("id"), "=>", $dstSelect.prop("id"));
        return $dstSelect;
    }
    normalizeBoxSelects() {
        $("#" + this.selectBox + CornerSelect.dlina3Suffix + ", #" + this.selectBox + CornerSelect.ugol2Suffix)
            .prop("disabled", ($('#' + this.selectBox + ' .corner-select-interactive-component g.active').length < 2))
    }
    normalizeBoxDlinas() {
        let shirina = +$("#" + this.selectBox + CornerSelect.shirinaSuffix).val(),
            $dlina1 = $("#" + this.selectBox + CornerSelect.dlina1Suffix),
            $dlina2 = $("#" + this.selectBox + CornerSelect.dlina2Suffix),
            $dlina3 = $("#" + this.selectBox + CornerSelect.dlina3Suffix);

        switch (this.selection.variant) {
            case "ITTC":
                $dlina1.find("> option").prop("disabled", false).parent().select2(VendorPlugins.select2_Search_Options());
                $dlina2.find("> option").prop("disabled", false).parent().select2(VendorPlugins.select2_Search_Options());
                $dlina3.find("> option").prop("disabled", false).parent().select2(VendorPlugins.select2_Search_Options());

                if (shirina === 200) {
                    $dlina1.find("> option").each((index, item) => {
                        if (item.value < 800)
                            item.disabled = "disabled";
                    });
                    if (+$dlina1.val() < 800)
                        $dlina1
                            .val(800)
                            .select2(VendorPlugins.select2_Search_Options());

                    $dlina2.find("> option").each((index, item) => {
                        if (item.value < 800)
                            item.disabled = "disabled";
                    });
                    if (+$dlina2.val() < 800)
                        $dlina2
                            .val(800)
                            .select2(VendorPlugins.select2_Search_Options());

                    $dlina3.find("> option").each((index, item) => {
                        if (item.value < 800)
                            item.disabled = "disabled";
                    });
                    if (+$dlina3.val() < 800)
                        $dlina3
                            .val(800)
                            .select2(VendorPlugins.select2_Search_Options());

                } else if (shirina === 250 || shirina === 300) {
                    $dlina1.find("> option").each((index, item) => {
                        if (item.value < 900)
                            item.disabled = "disabled";
                    });
                    $dlina2.find("> option").each((index, item) => {
                        if (item.value < 900)
                            item.disabled = "disabled";
                    });
                    $dlina3.find("> option").each((index, item) => {
                        if (item.value < 900)
                            item.disabled = "disabled";
                    });

                    if (+$dlina1.val() < 900)
                        $dlina1
                            .val(900)
                            .select2(VendorPlugins.select2_Search_Options());
                    if (+$dlina2.val() < 900)
                        $dlina2
                            .val(900)
                            .select2(VendorPlugins.select2_Search_Options());
                    if (+$dlina3.val() < 900)
                        $dlina3
                            .val(900)
                            .select2(VendorPlugins.select2_Search_Options());
                } else if (shirina === 350 || shirina === 400) {
                    $dlina1.find("> option").each((index, item) => {
                        if (item.value < 1000)
                            item.disabled = "disabled";
                    });
                    $dlina2.find("> option").each((index, item) => {
                        if (item.value < 1000)
                            item.disabled = "disabled";
                    });
                    $dlina3.find("> option").each((index, item) => {
                        if (item.value < 1000)
                            item.disabled = "disabled";
                    });

                    if (+$dlina1.val() < 1000)
                        $dlina1
                            .val(1000)
                            .select2(VendorPlugins.select2_Search_Options());
                    if (+$dlina2.val() < 1000)
                        $dlina2
                            .val(1000)
                            .select2(VendorPlugins.select2_Search_Options());
                    if (+$dlina3.val() < 1000)
                        $dlina3
                            .val(1000)
                            .select2(VendorPlugins.select2_Search_Options());
                }
                break;
            case "ITTBC":
                $dlina1.find("> option").prop("disabled", false).parent().select2(VendorPlugins.select2_Search_Options());
                $dlina2.find("> option").prop("disabled", false).parent().select2(VendorPlugins.select2_Search_Options());
                $dlina3.find("> option").prop("disabled", false).parent().select2(VendorPlugins.select2_Search_Options());

                if (shirina === 250 || shirina === 300) {
                    $dlina1.find("> option").each((index, item) => {
                        if (item.value < 1100)
                            item.disabled = "disabled";
                    });
                    $dlina2.find("> option").each((index, item) => {
                        if (item.value < 1100)
                            item.disabled = "disabled";
                    });
                    $dlina3.find("> option").each((index, item) => {
                        if (item.value < 1100)
                            item.disabled = "disabled";
                    });
                    $dlina1
                        .val(1100)
                        .select2(VendorPlugins.select2_Search_Options());
                    $dlina2
                        .val(1100)
                        .select2(VendorPlugins.select2_Search_Options());
                    $dlina3
                        .val(1100)
                        .select2(VendorPlugins.select2_Search_Options());
                } else if (shirina === 350 || shirina === 400) {
                    $dlina1.find("> option").each((index, item) => {
                        if (item.value < 1200)
                            item.disabled = "disabled";
                    });
                    $dlina2.find("> option").each((index, item) => {
                        if (item.value < 1200)
                            item.disabled = "disabled";
                    });
                    $dlina3.find("> option").each((index, item) => {
                        if (item.value < 1200)
                            item.disabled = "disabled";
                    });
                    $dlina1
                        .val(1200)
                        .select2(VendorPlugins.select2_Search_Options());
                    $dlina2
                        .val(1200)
                        .select2(VendorPlugins.select2_Search_Options());
                    $dlina3
                        .val(1200)
                        .select2(VendorPlugins.select2_Search_Options());
                }
                break;
            case "ITTLC":
                $dlina1.find("> option").prop("disabled", false).parent().select2(VendorPlugins.select2_Search_Options());
                $dlina2.find("> option").prop("disabled", false).parent().select2(VendorPlugins.select2_Search_Options());
                $dlina3.find("> option").prop("disabled", false).parent().select2(VendorPlugins.select2_Search_Options());

                if (shirina === 160) {
                    $dlina1.find("> option").each((index, item) => {
                        if (item.value < 800)
                            item.disabled = "disabled";
                    });
                    $dlina2.find("> option").each((index, item) => {
                        if (item.value < 800)
                            item.disabled = "disabled";
                    });
                    $dlina3.find("> option").each((index, item) => {
                        if (item.value < 800)
                            item.disabled = "disabled";
                    });
                    $dlina1
                        .val(800)
                        .select2(VendorPlugins.select2_Search_Options());
                    $dlina2
                        .val(800)
                        .select2(VendorPlugins.select2_Search_Options());
                    $dlina3
                        .val(800)
                        .select2(VendorPlugins.select2_Search_Options());
                } else if (shirina === 220 || shirina === 280) {
                    $dlina1.find("> option").each((index, item) => {
                        if (item.value < 900)
                            item.disabled = "disabled";
                    });
                    $dlina2.find("> option").each((index, item) => {
                        if (item.value < 900)
                            item.disabled = "disabled";
                    });
                    $dlina3.find("> option").each((index, item) => {
                        if (item.value < 900)
                            item.disabled = "disabled";
                    });
                    $dlina1
                        .val(900)
                        .select2(VendorPlugins.select2_Search_Options());
                    $dlina2
                        .val(900)
                        .select2(VendorPlugins.select2_Search_Options());
                    $dlina3
                        .val(900)
                        .select2(VendorPlugins.select2_Search_Options());
                } else if (shirina === 340 || shirina === 400) {
                    $dlina1.find("> option").each((index, item) => {
                        if (item.value < 1000)
                            item.disabled = "disabled";
                    });
                    $dlina2.find("> option").each((index, item) => {
                        if (item.value < 1000)
                            item.disabled = "disabled";
                    });
                    $dlina3.find("> option").each((index, item) => {
                        if (item.value < 1000)
                            item.disabled = "disabled";
                    });
                    $dlina1
                        .val(1000)
                        .select2(VendorPlugins.select2_Search_Options());
                    $dlina2
                        .val(1000)
                        .select2(VendorPlugins.select2_Search_Options());
                    $dlina3
                        .val(1000)
                        .select2(VendorPlugins.select2_Search_Options());
                }
                break;
            case "ITTBLC":
                $dlina1.find("> option").prop("disabled", false).parent().select2(VendorPlugins.select2_Search_Options());
                $dlina2.find("> option").prop("disabled", false).parent().select2(VendorPlugins.select2_Search_Options());
                $dlina3.find("> option").prop("disabled", false).parent().select2(VendorPlugins.select2_Search_Options());

                if (shirina === 220 || shirina === 280) {
                    $dlina1.find("> option").each((index, item) => {
                        if (item.value < 1100)
                            item.disabled = "disabled";
                    });
                    $dlina2.find("> option").each((index, item) => {
                        if (item.value < 1100)
                            item.disabled = "disabled";
                    });
                    $dlina3.find("> option").each((index, item) => {
                        if (item.value < 1100)
                            item.disabled = "disabled";
                    });
                    $dlina1
                        .val(1100)
                        .select2(VendorPlugins.select2_Search_Options());
                    $dlina2
                        .val(1100)
                        .select2(VendorPlugins.select2_Search_Options());
                    $dlina3
                        .val(1100)
                        .select2(VendorPlugins.select2_Search_Options());
                } else if (shirina === 340 || shirina === 400) {
                    $dlina1.find("> option").each((index, item) => {
                        if (item.value < 1200)
                            item.disabled = "disabled";
                    });
                    $dlina2.find("> option").each((index, item) => {
                        if (item.value < 1200)
                            item.disabled = "disabled";
                    });
                    $dlina3.find("> option").each((index, item) => {
                        if (item.value < 1200)
                            item.disabled = "disabled";
                    });
                    $dlina1
                        .val(1200)
                        .select2(VendorPlugins.select2_Search_Options());
                    $dlina2
                        .val(1200)
                        .select2(VendorPlugins.select2_Search_Options());
                    $dlina3
                        .val(1200)
                        .select2(VendorPlugins.select2_Search_Options());
                }
                break;
            case "ITTZC":
                $dlina1.find("> option").prop("disabled", false).parent().select2(VendorPlugins.select2_Search_Options());
                $dlina2.find("> option").prop("disabled", false).parent().select2(VendorPlugins.select2_Search_Options());
                $dlina3.find("> option").prop("disabled", false).parent().select2(VendorPlugins.select2_Search_Options());

                if (shirina === 200) {
                    $dlina1.find("> option").each((index, item) => {
                        if (item.value < 800)
                            item.disabled = "disabled";
                    });
                    $dlina2.find("> option").each((index, item) => {
                        if (item.value < 800)
                            item.disabled = "disabled";
                    });
                    $dlina3.find("> option").each((index, item) => {
                        if (item.value < 800)
                            item.disabled = "disabled";
                    });
                    $dlina1
                        .val(800)
                        .select2(VendorPlugins.select2_Search_Options());
                    $dlina2
                        .val(800)
                        .select2(VendorPlugins.select2_Search_Options());
                    $dlina3
                        .val(800)
                        .select2(VendorPlugins.select2_Search_Options());
                } else if (shirina === 250 || shirina === 300) {
                    $dlina1.find("> option").each((index, item) => {
                        if (item.value < 900)
                            item.disabled = "disabled";
                    });
                    $dlina2.find("> option").each((index, item) => {
                        if (item.value < 900)
                            item.disabled = "disabled";
                    });
                    $dlina3.find("> option").each((index, item) => {
                        if (item.value < 900)
                            item.disabled = "disabled";
                    });
                    $dlina1
                        .val(900)
                        .select2(VendorPlugins.select2_Search_Options());
                    $dlina2
                        .val(900)
                        .select2(VendorPlugins.select2_Search_Options());
                    $dlina3
                        .val(900)
                        .select2(VendorPlugins.select2_Search_Options());
                } else if (shirina === 350 || shirina === 400) {
                    $dlina1.find("> option").each((index, item) => {
                        if (item.value < 1000)
                            item.disabled = "disabled";
                    });
                    $dlina2.find("> option").each((index, item) => {
                        if (item.value < 1000)
                            item.disabled = "disabled";
                    });
                    $dlina3.find("> option").each((index, item) => {
                        if (item.value < 1000)
                            item.disabled = "disabled";
                    });
                    $dlina1
                        .val(1000)
                        .select2(VendorPlugins.select2_Search_Options());
                    $dlina2
                        .val(1000)
                        .select2(VendorPlugins.select2_Search_Options());
                    $dlina3
                        .val(1000)
                        .select2(VendorPlugins.select2_Search_Options());
                }
                break;
            case "ITTBZC":
                $dlina1.find("> option").prop("disabled", false).parent().select2(VendorPlugins.select2_Search_Options());
                $dlina2.find("> option").prop("disabled", false).parent().select2(VendorPlugins.select2_Search_Options());
                $dlina3.find("> option").prop("disabled", false).parent().select2(VendorPlugins.select2_Search_Options());

                if (shirina === 250 || shirina === 300) {
                    $dlina1.find("> option").each((index, item) => {
                        if (item.value < 1100)
                            item.disabled = "disabled";
                    });
                    $dlina2.find("> option").each((index, item) => {
                        if (item.value < 1100)
                            item.disabled = "disabled";
                    });
                    $dlina3.find("> option").each((index, item) => {
                        if (item.value < 1100)
                            item.disabled = "disabled";
                    });
                    $dlina1
                        .val(1100)
                        .select2(VendorPlugins.select2_Search_Options());
                    $dlina2
                        .val(1100)
                        .select2(VendorPlugins.select2_Search_Options());
                    $dlina3
                        .val(1100)
                        .select2(VendorPlugins.select2_Search_Options());
                } else if (shirina === 350 || shirina === 400) {
                    $dlina1.find("> option").each((index, item) => {
                        if (item.value < 1200)
                            item.disabled = "disabled";
                    });
                    $dlina2.find("> option").each((index, item) => {
                        if (item.value < 1200)
                            item.disabled = "disabled";
                    });
                    $dlina3.find("> option").each((index, item) => {
                        if (item.value < 1200)
                            item.disabled = "disabled";
                    });
                    $dlina1
                        .val(1200)
                        .select2(VendorPlugins.select2_Search_Options());
                    $dlina2
                        .val(1200)
                        .select2(VendorPlugins.select2_Search_Options());
                    $dlina3
                        .val(1200)
                        .select2(VendorPlugins.select2_Search_Options());
                }
                break;
        }

        return this;
    }
    onChange() {
        let $rectGroup = $('#' + this.selectBox + ' .corner-select-interactive-component rect').parent(),
            $actives = $rectGroup.parent().find('g.active');

        $rectGroup.parent().append($rectGroup).append($actives);

        let num = 1,
            $left = $actives.filter('.left'),
            $right = $actives.filter('.right');
        if ($left.length > 0) {
            $left.find("text.badge").text(num++);
            $left.find("text.arc-badge").text("C1");
        }
        $rectGroup.find("text.badge").text(num++);
        if ($right.length > 0) {
            $right.find("text.badge").text(num);
            $right.find("text.arc-badge").text("C" + (num -1));
        }

        this.normalizeBoxSelects();
    }
    onConfirm() {
        let $shirina = $("#" + this.variant + CornerSelect.shirinaSuffix);

        $("#" + this.variant + CornerSelect.cornerImageSuffix)
            .html($('#' + this.selectBox + ' .corner-select-interactive-component').html());

        this.cloneOptions(
            $("#" + this.selectBox + CornerSelect.visotaSuffix),
            $("#" + this.variant + CornerSelect.visotaSuffix)
        )//.trigger("change");
        this.cloneOptions(
            $("#" + this.selectBox + CornerSelect.shirinaSuffix),
            $shirina
        )//.trigger("change");
        this.cloneOptions(
            $("#" + this.selectBox + CornerSelect.dlina1Suffix),
            $("#" + this.variant + CornerSelect.dlina1Suffix)
        )//.trigger("change");
        this.cloneOptions(
            $("#" + this.selectBox + CornerSelect.dlina2Suffix),
            $("#" + this.variant + CornerSelect.dlina2Suffix)
        )//.trigger("change");
        this.cloneOptions(
            $("#" + this.selectBox + CornerSelect.dlina3Suffix),
            $("#" + this.variant + CornerSelect.dlina3Suffix)
        )//.trigger("change");

        $("#" + this.variant + CornerSelect.ugol1Suffix).val($("#" + this.selectBox + CornerSelect.ugol1Suffix).val())
            .trigger("change");
        $("#" + this.variant + CornerSelect.ugol2Suffix).val($("#" + this.selectBox + CornerSelect.ugol2Suffix).val())
            .prop("disabled", ($('#' + this.selectBox + ' .corner-select-interactive-component g.active').length < 2))
            .trigger("change");

        // $("#" + this.variant + CornerSelect.dlina3Suffix + ", #" + this.variant + CornerSelect.ugol2Suffix)
        //     .prop("disabled", ($('#' + this.selectBox + ' .corner-select-interactive-component g.active').length < 2));
        $("#" + this.variant + CornerSelect.dlina3Suffix)
            .prop("disabled", ($('#' + this.selectBox + ' .corner-select-interactive-component g.active').length < 2))
            .trigger("change");

        $('#' + this.selectBox).modal("hide");
        // $('.variants-menu a[data-toggle=pill][href="#' + this.variant + '"]').tab("dispose");
        //todo BUG on wrong behaviour of saving the sizes when confirm SelectBox
        // $shirina.trigger("change");
    }
    loadControlsValues(event) {
        this.variant = $(event.relatedTarget).closest(".tab-pane").prop("id");

        let $shirina = $("#" + this.selectBox + CornerSelect.shirinaSuffix);

        this.cloneOptions(
            $("#" + this.variant + CornerSelect.visotaSuffix),
            $("#" + this.selectBox + CornerSelect.visotaSuffix)
        ).trigger("change");
        this.cloneOptions(
            $("#" + this.variant + CornerSelect.shirinaSuffix),
            $shirina
        ).trigger("change");
        this.cloneOptions(
            $("#" + this.variant + CornerSelect.dlina1Suffix),
            $("#" + this.selectBox + CornerSelect.dlina1Suffix)
        ).trigger("change");
        this.cloneOptions(
            $("#" + this.variant + CornerSelect.dlina2Suffix),
            $("#" + this.selectBox + CornerSelect.dlina2Suffix)
        ).trigger("change");

        this.cloneOptions(
            $("#" + this.variant + CornerSelect.dlina3Suffix),
            $("#" + this.selectBox + CornerSelect.dlina3Suffix)
        ).trigger("change");

        $("#" + this.selectBox + CornerSelect.ugol1Suffix).val($("#" + this.variant + CornerSelect.ugol1Suffix).val());
        $("#" + this.selectBox + CornerSelect.ugol2Suffix).val($("#" + this.variant + CornerSelect.ugol2Suffix).val());

        $shirina.on("change", () => this.normalizeBoxDlinas());

        this.normalizeBoxDlinas();
    }
    finalizeBox() {}

    get selection () {
        this.selected = {
            series: $('.convectors > .active').prop("id"),
            variant: $('.convectors > .active .variants > .active').prop("id"),
            previous: this.selected
        };

        return this.selected;
    }

}

export default CornerSelect;